import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { company } from '~/company/Company';
import { CartNotification } from '~/components/Header/components/CartNotification';
import { useModal } from '~/hooks/useModal';
import { useMounted } from '~/hooks/useMounted';
import useNavigateCart from '~/hooks/useNavigateCart';
import { cartStore, userStore } from '~/stores';

import Icon from '../../Icon/Icon';
import { ModalType } from '../../Modal/interface';
import ModalCart from '../../ModalCart/ModalCart';
import styles from './NavButtons.module.scss';

export const NavButtons = observer(() => {
  const { openModal } = useModal();
  const { t } = useTranslation();
  const location = useLocation();
  const mounted = useMounted();
  const isAuthorized = mounted && userStore.isAuthorized;
  const [showCartModal, setShowCartModal] = useState(false);

  const handleNavigateCart = useNavigateCart({
    beforeNavigate: () => {
      if (showCartModal) {
        setShowCartModal(false);
      }
    },
    source: 'NavButtons',
  });

  const handleAuth = (e: unknown) => {
    if (userStore.isAuthorized) {
      return;
    }
    (e as MouseEvent).preventDefault();
    openModal(ModalType.Auth, 'header', { redirect: '/cabinet' });
  };

  return (
    <div className={styles.header_btn_group} data-company={company.name}>
      {userStore.isAuthorized && (
        <Link data-link="header-favs" to="/favs" className={styles.header_btn}>
          <Icon type="fav" size={24} className={styles.header_btn__icon} />
          <div className={styles.header_btn__text}>{t('favs')}</div>
        </Link>
      )}
      <Link
        data-link="header-cabinet"
        to="/cabinet"
        className={styles.header_btn}
        onClick={handleAuth}
      >
        <Icon type="profile" size={24} className={styles.header_btn__icon} />
        <div className={styles.header_btn__text}>
          {t(isAuthorized ? 'cabinet' : 'logIn')}
        </div>
      </Link>
      <div
        data-button="header-checkout"
        className={styles.header_btn}
        onMouseLeave={() => setShowCartModal(false)}
        onClick={handleNavigateCart}
      >
        <div
          data-button="header-cart"
          onMouseEnter={() =>
            cartStore.totalCartCount > 0 &&
            !['/cart', '/checkout'].includes(location.pathname) &&
            setShowCartModal(true)
          }
        >
          <Icon type="bag" size={24} className={styles.header_btn__icon} />
          {mounted && cartStore.totalCartCount > 0 && (
            <div className={styles.header_btn__count}>
              {cartStore.totalCartCount}
            </div>
          )}
        </div>
        <div className={styles.header_btn__text}>{t('cart')}</div>
        {showCartModal && !!cartStore.cart.length && (
          <ModalCart onClose={() => setShowCartModal(false)} />
        )}
        <CartNotification />
      </div>
    </div>
  );
});
